import { useAppContext } from '../../context/app-context';
import { useHealthProviderItems } from './use-health-provider-items';

const useCurrentHealthProvider = () => {
  const { healthProviderId } = useAppContext();

  const { data: healthProvidersData } = useHealthProviderItems();

  const healthProvider = healthProvidersData?.find(
    x => x.id === healthProviderId
  );

  return { healthProvider };
};

export { useCurrentHealthProvider };
